import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { visible, opts, uploaderRef, resolver, rejecter } from './asset-upload'
import TrellisFileUpload from '../import/TrellisFileUpload.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetUploader',
  setup(__props) {

const files = ref<File[]>([])
function onUpload (f: File) {
  files.value.push(f)
}

function onDone () {
  if (files.value.length && resolver.value) {
    resolver.value(files.value)
  } else {
    rejecter.value(new Error('No files uploaded'))
  }
  files.value = []
}


return { __sfc: true,files, onUpload, onDone, visible, opts, uploaderRef, TrellisFileUpload }
}

})